import apiClient from './apiClient';

// Documentation APIs
export const getDocumentationEntries = async (skip = 0, limit = 50, legacy = false, createdBy = null, staffId = null, search = null, warehouse = null) => {
  const params = new URLSearchParams({ skip, limit, legacy });
  if (createdBy) params.append('created_by', createdBy);
  if (staffId) params.append('staff_id', staffId);
  if (search) params.append('search', search);
  if (warehouse) params.append('warehouse', warehouse);
  const response = await apiClient.get(`/documentation/entries?${params.toString()}`);
  return response.data;
};

export const listInwardUploaders = async () => {
  const response = await apiClient.get('/documentation/entries/uploaders');
  return response.data;
};

export const extractDocumentation = async (entryId) => {
  const response = await apiClient.post(`/documentation/extract/${entryId}`);
  return response.data;
};

export const updateDocumentation = async (entryId, data) => {
  const response = await apiClient.put(`/documentation/update/${entryId}`, data);
  return response.data;
};

export const confirmDocumentation = async (entryId, linkedInternalTransferId = null) => {
  if (linkedInternalTransferId) {
    const response = await apiClient.post(`/documentation/confirm/${entryId}/with-link`, {
      linked_internal_transfer_id: linkedInternalTransferId
    });
    return response.data;
  }
  const response = await apiClient.post(`/documentation/confirm/${entryId}`);
  return response.data;
};

export const getPendingInternalTransfers = async (section) => {
  const response = await apiClient.get(`/documentation/pending-internal-transfers?section=${encodeURIComponent(section)}`);
  return response.data;
};

export const getSections = async () => {
  const response = await apiClient.get('/documentation/sections');
  return response.data;
};

// Import Section Master
export const importSections = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await apiClient.post('/imports/sections', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};
